import { ActionContext } from 'vuex';
import store from '..';

const storeState: {
  errors: Record<string, string[]>,
  showModal: boolean,
} = {
  errors: {},
  showModal: false,
};

export default {
  namespaced: true,

  state: storeState,

  getters: {
    errors: (state: typeof storeState) => Object
      .keys(state.errors)
      .filter((key) => state.errors[key].length > 0)
      .reduce((acc, cur) => ({ ...acc, [cur]: state.errors[cur] }), {}),

    showModal: (state: typeof storeState) => state.showModal,
  },

  mutations: {
    setErrors: (state: typeof storeState, payload: Record<string, string[]>) => {
      state.errors = payload;
    },

    setModalState: (state: typeof storeState, payload: boolean) => {
      state.showModal = payload;
    },
  },

  actions: {
    showSummary: (
      ctx: ActionContext<typeof storeState, typeof store['state']>,
      // vee-validate v4's `validate()` returns errors as `Record<string, string>`
      // (one message per field), whereas v3 returned `string[]`. Callers spread that
      // shape straight in, so accept both a single message and an array and normalize
      // to `string[]`. The modal renders one line per array entry; a bare string would
      // otherwise be iterated character-by-character.
      payload: Record<string, string | string[]>,
    ) => {
      const normalized = Object.keys(payload).reduce<Record<string, string[]>>((acc, key) => {
        const value = payload[key];
        acc[key] = Array.isArray(value) ? value : [value];
        return acc;
      }, {});

      ctx.commit('setErrors', normalized);

      if (Object.keys(normalized).length) {
        ctx.commit('setModalState', true);
      }
    },

    dismissSummary: (
      ctx: ActionContext<typeof storeState, typeof store['state']>,
      payload?: {},
    ) => {
      ctx.commit('setErrors', []);
      ctx.commit('setModalState', false);
    },
  },
};
